import { APP_STATUS, type StatusLine } from "../data/status";
import { StatusMark } from "./StatusMark";

// Statuses that share a line style share one legend entry.
function legendEntries(): { line: StatusLine; labels: string[] }[] {
  const entries: { line: StatusLine; labels: string[] }[] = [];
  for (const { label, line } of Object.values(APP_STATUS)) {
    const existing = entries.find((e) => e.line === line);
    if (existing) existing.labels.push(label);
    else entries.push({ line, labels: [label] });
  }
  return entries;
}

export function StatusLegend() {
  return (
    <ul
      aria-label="App status"
      className="mt-3 flex flex-wrap items-center justify-center gap-x-5 gap-y-1 text-[10px] uppercase tracking-wider text-white/35"
    >
      {legendEntries().map(({ line, labels }) => (
        <li key={line} className="flex items-center gap-2">
          <StatusMark
            line={line}
            diameter={12}
            color="rgba(255,255,255,0.45)"
          />
          <span>{labels.join(" / ")}</span>
        </li>
      ))}
    </ul>
  );
}
